module.exports = __webpack_public_path__ + "media/partners/on-9a7775b9.svg";